import React from 'react'

export default function ProfileLoading() {
    return (

        <>
            <section className="inner-section profile-part mt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-xl-3">
                            <div className="account-card">
                                <div className="profile-image text-center py-3">
                                    <a className='remove' href="/profile"><span className='skeleton'></span></a>
                                </div>
                                <h2 className="card-title skeleton">
                                    <p className="p-2"></p>
                                </h2>
                                <h2 className="card-title skeleton">
                                    <p className="p-2"></p>
                                </h2>
                                <div className="section-btn-25">
                                    <button className="btn-6 view-all-btnn skeleton">
                                        <span className='p-5'></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9 col-xl-9">
                            <div className="account-card">
                                <div className="account-title d-none">
                                    <h4>statistics</h4>
                                </div>

                                <div className="account-content pt-4 d-none">
                                    <div className="row our-profile">

                                        <div className="col-md-3">
                                            <div className="product-card skeleton">
                                                <div className="row align-items-center">
                                                
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="product-card skeleton">
                                                <div className="row align-items-center">

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="product-card skeleton">
                                                <div className="row align-items-center">

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="product-card skeleton">
                                                <div className="row align-items-center">

                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className="account-title">
                                    <h4>Your Profile</h4>

                                </div>
                                <div className="account-content">
                                    <div className="row">
                                        <div className="col-md-6 col-lg-4">
                                            <h2 className="card-title skeleton">
                                                <p className="p-4"></p>
                                            </h2>
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <h2 className="card-title skeleton">
                                                <p className="p-4"></p>
                                            </h2>
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <h2 className="card-title skeleton">
                                                <p className="p-4"></p>
                                            </h2>
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <h2 className="card-title skeleton">
                                                <p className="p-4"></p>
                                            </h2>
                                        </div>

                                        <div className="col-md-6 col-lg-4">
                                            <h2 className="card-title skeleton">
                                                <p className="p-4"></p>
                                            </h2>
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <h2 className="card-title skeleton">
                                                <p className="p-4"></p>
                                            </h2>
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <h2 className="card-title skeleton">
                                                <p className="p-4"></p>
                                            </h2>
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <h2 className="card-title skeleton">
                                                <p className="p-4"></p>
                                            </h2>
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <h2 className="card-title skeleton">
                                                <p className="p-4"></p>
                                            </h2>
                                        </div>
                                        <div className="col-lg-12 ">
                                            <div className="section-btn-25">
                                                <button className="btn-6 view-all-btnn skeleton "><span className=' p-5'></span></button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>

        </>
    )
}

